export class ImageUtils {

    public static resizeImage(base64: string, requiredSize: number): Promise<string> {
        const image: HTMLImageElement = new Image();
        const canvas: HTMLCanvasElement = document.createElement("canvas");

        return new Promise((resolve, reject) => {
            const currentSize: number = this.getBinarySize(base64);
            if (currentSize <= requiredSize) {
                resolve(base64);
                return;
            }
            const factor: number = Math.sqrt(currentSize / requiredSize);
            image.onload = () => {
                const width: number = image.width / factor;
                const height: number = image.height / factor;
                canvas.width = width;
                canvas.height = height;
                const context: CanvasRenderingContext2D = canvas.getContext("2d");
                context.clearRect(0, 0, width, height);
                context.drawImage(image, 0, 0, width, height);
                const dataUrl: string = canvas.toDataURL();
                const resizedBase64: string = this.dataURLtoBase64(dataUrl);
                if (this.getBinarySize(resizedBase64) > requiredSize) {
                    this.resizeImage(resizedBase64, requiredSize)
                        .then((furtherResizedBase64: string) => {
                            resolve(furtherResizedBase64);
                        });
                } else {
                    resolve(resizedBase64);
                }
            };
            image.src = this.base64TotoDataURL(base64);
        })
    }

    public static dataURLtoBase64(dataUrl: string): string {
        return dataUrl.substring(dataUrl.indexOf(",") + 1);
    }

    public static base64TotoDataURL(base64: string): string {
        return "data:image;base64," + base64;
    }

    public static getBinarySize(base64: string): number {
        return base64.length / 4 * 3;
    }

    public static base64ToSvg(base64: string) {
        if (base64 == undefined || base64.length == 0) {
            return undefined;
        }
        const bytes: string = atob(base64);
        if (bytes.match(/^<svg\b/)) {
            return bytes;
        }
        if (bytes.match(/^<\?xml\b/)) {
            const i: number = bytes.search(/<svg\b/);
            return i == -1 ? undefined : bytes.slice(i);
        }
        return undefined;
    }
}
